import axios from 'axios';
import { API_URL } from '../../config/api';
import { ActionInput, Pending } from './SubscriptionConfirm';
import { isGift, Subscription, tierLabels } from './model';

export async function performSubscriptionAction(pending: Pending, input: ActionInput): Promise<{ message: string; failed?: Subscription[] }> {
  if (pending.kind === 'grant') {
    if (!Number.isSafeInteger(input.userId) || input.userId <= 0 || ![7, 30, 90, 180, 365].includes(input.days) || !Object.prototype.hasOwnProperty.call(tierLabels, input.tier)) throw new Error('Invalid grant input');
    await axios.post(`${API_URL}/admin/subscriptions/grant-premium/${input.userId}`, null, { params: { days: input.days, tier: input.tier } });
    return { message: `Kullanıcı #${input.userId} için ${input.days} günlük ${tierLabels[input.tier]} tanımlandı.` };
  }
  if (pending.kind === 'bulk') {
    const failed: Subscription[] = [];
    for (let index = 0; index < pending.items.length; index += 1) {
      const item = pending.items[index];
      if (!isGift(item) || item.is_valid) { failed.push(item); continue; }
      try { await axios.delete(`${API_URL}/admin/subscriptions/${item.id}`); }
      catch (error) {
        failed.push(item);
        if (axios.isAxiosError(error) && [401, 403, 429].includes(error.response?.status || 0)) { failed.push(...pending.items.slice(index + 1)); break; }
      }
    }
    return { message: `${pending.items.length - failed.length}/${pending.items.length} hediye kaydı silindi.`, failed };
  }
  if (pending.kind === 'delete') {
    if (!isGift(pending.item)) throw new Error('Only gift records can be deleted here');
    await axios.delete(`${API_URL}/admin/subscriptions/${pending.item.id}`);
    return { message: 'Hediye abonelik kaydı silindi.' };
  }
  if (pending.kind === 'extend' && ![7, 30, 90].includes(input.days)) throw new Error('Invalid extension');
  await axios.patch(`${API_URL}/admin/subscriptions/${pending.item.id}`, null, { params: pending.kind === 'extend' ? { is_active: true, extend_days: input.days } : { is_active: !pending.item.is_active } });
  return { message: pending.kind === 'extend' ? `Abonelik ${input.days} gün uzatıldı.` : 'Abonelik kaydı güncellendi.' };
}
